export interface StatNotificationInterface {
  /**
   * 总数
   */
  count: number
  /**
   * 未读总数
   */
  unreadCount: number
}

export class StatNotification implements StatNotificationInterface {
  /**
   * 总数
   */
  count: number
  /**
   * 未读总数
   */
  unreadCount: number

  constructor(props: StatNotificationInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      count: _count,
      unreadCount: _unreadCount,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.count = _count
    this.unreadCount = _unreadCount
  }
}
